export enum Nationality {
  BE = 'BE',
  FR = 'FR',
  NL = 'NL',
  DE = 'DE',
}
